import { connect } from "react-redux";
import PosReplacement from "./posReplacement";
import { bindActionCreators } from "redux";
import {
  getPosShipmentAndReasons,
  replaceOrReturnPos
} from "services/redux/installation/tagDelivery/action";

const mapStateToProps = (state) => ({
  posRequirement: state.tagDeliveryReducer.posReasonAndMaterials
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPosShipmentAndReasons,
      replaceOrReturnPos
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PosReplacement);
